<template>
  <div class="all">
    <div class="title">Auto Plan List</div>
    <div class="btns">
      <el-button size="small" style="background-color: rgb(129, 175, 201); color: white"
        @click="$router.push(`/autoPlan-editor?id=add`)">Add Auto Plan</el-button>
      <!-- <el-button size="small" type="danger" @click="deleteData">Delete</el-button> -->
    </div>
    <el-table :data="tableData" stripe ref="libraryTable" header-row-class-name="tableHeadr"
      v-loading="tableLoad" row-key="id" @selection-change="handleSelectionChange">
      <!-- <el-table-column type="selection" width="55"></el-table-column>     -->
      <el-table-column label="Name" width="200">
        <template slot="header">
          <div class="table-name" style="display: flex; align-items: center">
            <div>Name</div>
            <!-- <i
                            class="el-icon-circle-plus"
                            style="color: white; margin-left: 20px"
                            @click="
                                $router.push(
                                    `/workout-editor?id=add`
                                )
                            "
                        ></i> -->
          </div>
        </template>
        <template slot-scope="scope">
          <div class="tableCell" :title="scope.row.name" @click="$router.push(`/autoPlan-editor?id=${scope.row.id}`)">
            {{scope.row.name}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Cover Image" width="150">
        <template slot-scope="scope">
          <div style="height: 50px">
            <img style="height: 100%; width: 100px" :src="
              $store.state.default_file_url + scope.row.phoneCoverImageUrl
            " alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Detail Image" width="150">
        <template slot-scope="scope">
          <div style="height: 50px">
            <img style="height: 100%; width: 100px" :src="
              $store.state.default_file_url + scope.row.phoneDetailImageUrl
            " alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Total Days" prop="totalDays" min-width="150"></el-table-column>
      <el-table-column label="Free Days" prop="freeDays" min-width="150"></el-table-column>
      <el-table-column label="Short Link" prop="shortLink" min-width="150"></el-table-column>
      <el-table-column label="Create Time" prop="createTime" min-width="150"></el-table-column>
      <el-table-column label="Status" prop="status" min-width="150">
        <template slot-scope="scope" >
          <div
          :style="`color:${scope.row.status === 0?'rgb(224,141,0)':(scope.row.status === 1?'rgb(15,157,88)':'#d81e06')}`"
          >{{ scope.row.status === 0?'Runing':(scope.row.status === 1?'Success':'Failure') }}
          <i :class="scope.row.status === 0?'el-icon-more':(scope.row.status === 1?'el-icon-success':'el-icon-error')"></i></div>
        </template>
      </el-table-column>
      <el-table-column label="Message" prop="failMessage" min-width="150"></el-table-column>
      <el-table-column label="options" min-width="170">
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="$router.push(`/autoPlan-editor?id=${scope.row.id}`)">Detail</el-button>
            <!-- <el-button
                            size="mini"
                            @click="
                                $router.push(
                                    `/autoPlan-editor?id=${scope.row.id}`
                                )
                            "
                            >Duplicate</el-button
                        > -->
            <el-button size="mini" type="danger" @click="Delete(scope.row.id)">Delete</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div style="margin: 30px 0">
      <el-button
        size="small"
        @click="sortTable"
        type="success"
        style="background-color: #417690"
        >Save</el-button
      >
    </div> -->
    <el-pagination background layout="total,sizes,prev, pager, next,jumper" :total="total" :pager-count="5"
      :page-size.sync="pageSize" :current-page.sync="nowPage" :page-sizes="[15, 40, 50, 60, 100]">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      pageSize: 15,
      total: 0,
      nowPage: 1,
      tableLoad: false,
      tableSelect: [],
    };
  },
  watch: {
    nowPage: {
      handler() {
        this.$savePagination(this.$route.path, {
          pageSize: this.pageSize,
          nowPage: this.nowPage
        });
        this.getData();
      }
    },
    pageSize() {
      this.$savePagination(this.$route.path, {
        pageSize: this.pageSize,
        nowPage: this.nowPage
      });
      this.getData();
    }
  },
  methods: {
    sortTable() {
      this.$request(
        "/manage/autoPlan/sort",
        { idList: this.tableData.map((item) => item.id) },
        (res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "modify success",
              type: "success",
            });
          }
        },
        "post"
      );
    },
    handleSelectionChange(val) {
      this.tableSelect = val;
    },
    Delete(id) {
      this.$confirm("This will permanently delete the data. Continue?", "", { type: "warning" }).then(() => {
        this.$request(`/manage/autoPlan/del/${id}`, {}, (res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "delete success",
              type: "success",
            });
            this.getData();
          }
        });
      });
    },
    getData() {
      this.tableLoad = true;
      this.$request(
        "/manage/autoPlan/page",
        {
            "pageNum": this.nowPage,
            "pageSize": this.pageSize
        },
        (res) => {
          this.tableLoad = false;
          res.data.data.list.some((item) => {
            item.createTime = item.createTime.replace("T", " ");
            item.updateTime &&
              (item.updateTime = item.updateTime.replace("T", " "));
          });
          this.total = res.data.data.total
          this.tableData = res.data.data.list;
        },
        "post",
        true
      );
      this.tableLoad = false;
    },
  },
  created() {
    let data = this.$getPagination(this.$route.path);
    if (data) {
      data = JSON.parse(data);
      Object.keys(data).some(key => {
        this[key] = data[key];
      });
    }
    this.getData();
  },
  mounted() {
  },
};
</script>

<style scoped>
.all {
  box-sizing: border-box;
  padding: 0 20px;
  text-align: left;
  margin-top: 30px;
}

.title {
  font-size: 20px;
  margin: 40px 0 0;
}

.btns {
  margin: 0 0 2px;
  text-align: right;
}

.el-table {
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
}

.all>>>.tableHeadr th {
  background-color: rgb(121, 174, 200) !important;
  color: white;
}

.all>>>.table-name i:hover {
  color: #447e9b !important;
  cursor: pointer;
}

.all>>>.tableCell {
  color: #447e9b;
  width: 100%;
  /* overflow: hidden; */
  /* height: 23px; */
  /* text-overflow: ellipsis; */
  white-space: pre-line;
}

.all>>>.tableCell:hover {
  cursor: pointer;
  text-decoration: underline;
}

.el-pagination {
  text-align: right;
  margin: 20px 0;
}

.el-table>>>.el-table__row * {
  text-transform: none;
}

/* .el-table >>> .el-table__row {
  cursor: move;
} */
</style>